// Helpers that read both TheMealDB and Spoonacular recipe shapes the same way.

export const isSpoonacular = (recipe) => !!recipe?.extendedIngredients;

export const getRecipeId = (recipe) => String(recipe?.id ?? recipe?.idMeal ?? "");

export const getRecipeTitle = (recipe) => recipe?.title || recipe?.strMeal || "";

export const getRecipeImage = (recipe) => recipe?.image || recipe?.strMealThumb || "";

export const stripTags = (text) => String(text || "").replace(/<[^>]*>/g, "").trim();

export function getIngredients(recipe) {
  if (!recipe) return [];
  if (isSpoonacular(recipe)) {
    return recipe.extendedIngredients.map((ing, i) => ({
      id: ing.id ?? i,
      original: ing.original,
    }));
  }
  return Array.from({ length: 20 })
    .map((_, i) => {
      const ingredient = recipe[`strIngredient${i + 1}`];
      const measure = recipe[`strMeasure${i + 1}`];
      return ingredient && ingredient.trim()
        ? { id: i, original: `${measure || ""} ${ingredient}`.trim() }
        : null;
    })
    .filter(Boolean);
}

/** "simmer for 10-15 minutes" -> 15; "bake 1 hour" -> 60 */
export function guessMinutes(text) {
  const m = String(text).match(/(\d+)(?:\s*(?:-|–|to)\s*(\d+))?\s*(minutes?|mins?|hours?|hrs?)\b/i);
  if (!m) return undefined;
  const n = Number(m[2] || m[1]);
  return /^h/i.test(m[3]) ? n * 60 : n;
}

export function getSteps(recipe) {
  if (!recipe) return [];
  if (isSpoonacular(recipe)) {
    const steps = recipe.analyzedInstructions?.[0]?.steps || [];
    if (steps.length) {
      return steps.map((s) => ({
        text: stripTags(s.step),
        html: s.step,
        minutes: s.length?.number || guessMinutes(stripTags(s.step)),
      }));
    }
    return splitLines(stripTags(recipe.instructions));
  }
  return splitLines(recipe.strInstructions);
}

function splitLines(raw) {
  return String(raw || "")
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l && !/^step\s*\d+\.?$/i.test(l))
    .map((text) => ({ text, minutes: guessMinutes(text) }));
}

/** Small summary used by lists (recently viewed, planner, similar). */
export function toSummary(recipe) {
  return {
    id: getRecipeId(recipe),
    title: getRecipeTitle(recipe),
    image: getRecipeImage(recipe),
    isMealDB: !isSpoonacular(recipe),
  };
}
